import React from "react";
import infoImage from "../../assets/info_pic.png";
import { useTranslation } from "react-i18next";

export const Info: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div>
      <h3>{t("info_header")}</h3>
      <h2>{t("info_subheader")}</h2>
      <p>{t("info_body")}</p>
      <img alt="Info" src={infoImage} style={{ maxWidth: "100%" }} />
    </div>
  );
};
